import Flex from 'components/Flex';
import Text from "components/Text";
import { ErrorIcon } from '../Icons/Error';
import { useStyles } from "./styles";

type ErrorMessageProps = {
  message: string
}

export const ErrorMessage = ({message}: ErrorMessageProps) => {
  const { classes } = useStyles();
  
  return (
    <Flex direction="row" gap={6} >
      <ErrorIcon  alt="Error" className={classes.errorIcon}/>
      <Text as="div" sizeVariant="md" className={classes.error}>
        {message}
      </Text>
    </Flex>
  )
}